/**
 * ============================================================
 * GEF - PBC - BBF - CUSTOM ANALYTICS
 * ============================================================
 *
 * Eventos:
 *
 * 1. view_item_list_custom
 *    Vista macro de una PLP / colección.
 *
 * 2. view_item_list_product
 *    Impresión REAL de una card de producto.
 *    >= 50% visible durante >= 500 ms.
 *
 * 3. select_item
 *    Click real hacia PDP desde imagen o título.
 *
 * 4. change_item_variant_plp
 *    Cambio de color / producto relacionado desde PLP.
 *
 * 5. menu_interaction
 *    Interacción menú desktop/mobile.
 *
 * 6. plp_sort_interaction
 *    Cambio de ordenamiento.
 *
 * 7. plp_filter_interaction
 *    Aplicación / eliminación de filtros.
 *
 * ============================================================
 */
(function() {
	"use strict";
	if (window.__gefAnalyticsLoaded) return;
	window.__gefAnalyticsLoaded = true;
	window.dataLayer = window.dataLayer || [];
	/* ==========================================================
	   CONFIG
	========================================================== */
	var CONFIG = {
		brand: "Gef",
		currency: "COP",
		productSelector: 'hdt-card-product[data-dl-object="item"]',
		productVisibilityThreshold: 0.50,
		productVisibilityTime: 500,
		impressionBatchDelay: 350,
		debug: false
	};
	/* ==========================================================
	   STATE
	========================================================== */
	var STATE = {
		/**
		 * Versión lógica del render actual de la PLP.
		 *
		 * Aumenta cuando:
		 * - cambia un filtro
		 * - cambia el ordenamiento
		 *
		 * Esto permite que un producto pueda volver a registrar
		 * impresión después de que la PLP haya cambiado.
		 */
		renderVersion: 1,
		/**
		 * Evita duplicar view_item_list_custom
		 * para una misma colección durante la navegación actual.
		 */
		viewedLists: new Set(),
		/**
		 * Productos ya vistos dentro de un render.
		 */
		viewedProducts: new Set(),
		/**
		 * Timers de visibilidad.
		 */
		visibilityTimers: new Map(),
		/**
		 * Cards actualmente observadas.
		 */
		observedCards: new Set(),
		/**
		 *  Cola de productos que ya cumplieron la regla de visibilidad
		 */
		productImpressionQueue: [],
		/**
		 *  Timer para consolidar la tanda
		 */
		productImpressionFlushTimer: null
	};
	/* ==========================================================
	   HELPERS
	========================================================== */
	function getPageContext() {
		var path = window.location.pathname || "/";
		var context = "other";
		if (path === "/") {
			context = "home";
		} else if (path.indexOf("/collections/") === 0) {
			context = "collection";
		} else if (path.indexOf("/products/") === 0) {
			context = "product";
		} else if (path.indexOf("/search") === 0) {
			context = "search";
		} else if (path.indexOf("/pages/") === 0) {
			context = "page";
		}
		return {
			list_context: context,
			page_location_relative: path
		};
	}

	function getEventElement(event) {
		return event.target && event.target.nodeType === 1
			? event.target : (event.target && event.target.parentElement) || document.documentElement;
	}
	function cleanText(value) {
		if (!value) return "";
		return String(value).replace(/\s+/g, " ").trim();
	}

	function getDeviceType() {
		return window.innerWidth < 1024 ? "mobile" : "desktop";
	}

	function debugLog(name, data) {
		if (!CONFIG.debug) return;
		console.log("[GEF Analytics][" + name + "]", data);
	}

	function pushEvent(entry) {
		window.dataLayer.push(entry);
		debugLog(entry.event || "dataLayer", entry);
	}
	/**
	 * Limpia ecommerce antes de enviar uno nuevo.
	 *
	 * Evita que GTM mezcle datos ecommerce
	 * provenientes de eventos anteriores.
	 */
	function pushEcommerceEvent(entry) {
		window.dataLayer.push({
			ecommerce: null
		});
		window.dataLayer.push(entry);
		debugLog(entry.event, entry);
	}

	function safeJsonParse(value) {
		if (!value) return null;
		try {
			return JSON.parse(value);
		} catch (error) {
			return null;
		}
	}

	function normalizeReference(value) {
		if (!value) return "";
		return String(value).replace(/-/g, "_").trim();
	}
	/* ==========================================================
	   LIST / COLLECTION CONTEXT
	========================================================== */
	function getListContext(card) {
		var context = {
			item_list_id: "",
			item_list_name: ""
		};
		/**
		 * Primera fuente:
		 * atributos de la card.
		 */
		if (card) {
			context.item_list_id = card.getAttribute("data-dl-list-id") || "";
			context.item_list_name = card.getAttribute("data-dl-list-name") || "";
		}
		/**
		 * Segunda fuente:
		 * primera card disponible.
		 */
		if (!context.item_list_id) {
			var firstCard = document.querySelector(CONFIG.productSelector);
			if (firstCard) {
				context.item_list_id = firstCard.getAttribute("data-dl-list-id") || "";
				context.item_list_name = firstCard.getAttribute("data-dl-list-name") || "";
			}
		}
		/**
		 * Tercera fuente:
		 * listbox del ordenamiento.
		 *
		 * Ej:
		 *
		 * listbox310823583923
		 */
		if (!context.item_list_id) {
			var listbox = document.querySelector('hdt-richlist[id^="listbox"]');
			if (listbox) {
				context.item_list_id = listbox.id.replace(/^listbox/, "");
			}
		}
		return context;
	}
	/* ==========================================================
	   PRODUCT INDEX
	========================================================== */
	function getProductIndex(card) {
		// Se conserva el índice global original; se evita crear un array adicional.
		return Array.prototype.indexOf.call(document.querySelectorAll(CONFIG.productSelector), card);
	}
	/* ==========================================================
	   PRODUCT DATA
	========================================================== */
	function getSelectedColorElement(card) {
		if (!card) return null;
		return card.querySelector(".t4s-product-colors " + ".t4-variant-custom.is-swatch--selected");
	}

	function getProductJsonFromColor(colorElement) {
		if (!colorElement) return null;
		return safeJsonParse(colorElement.getAttribute("data-product"));
	}

	function getProductExtra(card) {
		if (!card) return {};
		return safeJsonParse(card.getAttribute("data-dl-extra")) || {};
	}

	function getVisiblePrice(card) {
		if (!card) return 0;
		var priceElement = card.querySelector(".hdt-price__list .hdt-money");
		if (!priceElement) return 0;
		var text = priceElement.textContent || "";
		/**
		 * COP:
		 *
		 * $169,990
		 *
		 * =>
		 *
		 * 169990
		 */
		var number = text.replace(/[^0-9]/g, "");
		return Number(number) || 0;
	}
	/**
	 * Construye un item GA4 consistente.
	 *
	 * Fuente principal:
	 * swatch actualmente seleccionado.
	 *
	 * Fallback:
	 * atributos originales de la card.
	 */
	function buildProductItem(card, forcedColorElement) {
		if (!card) return null;
		var list = getListContext(card);
		var extra = getProductExtra(card);
		var colorElement = forcedColorElement || getSelectedColorElement(card);
		var product = getProductJsonFromColor(colorElement);
		/* =========================
		   SHOPIFY PRODUCT ID
		========================= */
		var itemId = "";
		if (colorElement) {
			itemId = colorElement.getAttribute("data-id") || "";
		}
		if (!itemId && product) {
			itemId = product.id || "";
		}
		if (!itemId) {
			itemId = card.getAttribute("data-id") || "";
		}
		/* =========================
		   REFERENCIA COLOR
		========================= */
		var itemRefCol = "";
		/**
		 * Si tenemos el producto del swatch,
		 * intentamos usar barcode.
		 */
		if (product && product.variants && product.variants.length) {
			itemRefCol = product.variants[0].barcode || "";
		}
		/**
		 * Fallback:
		 * handle.
		 */
		if (!itemRefCol && product) {
			itemRefCol = product.handle || "";
		}
		/**
		 * Fallback:
		 * data-dl-extra.
		 */
		if (!itemRefCol) {
			itemRefCol = extra.referencia_color || "";
		}
		itemRefCol = normalizeReference(itemRefCol);
		/* =========================
		   NAME
		========================= */
		var itemName = "";
		if (product && product.title) {
			itemName = product.title;
		}
		if (!itemName) {
			var title = card.querySelector(".hdt-card-product__title");
			if (title) {
				itemName = cleanText(title.textContent);
			}
		}
		/* =========================
		   BRAND
		========================= */
		var itemBrand = product && product.vendor ? product.vendor : CONFIG.brand;
		/* =========================
		    PHOTO
		========================= */
		var itemImageUrl = "";
		if (product && product.featured_image) {
			itemImageUrl = String(product.featured_image);
			if (itemImageUrl.indexOf("//") === 0) {
				itemImageUrl = "https:" + itemImageUrl;
			}
		}
		/* =========================
		   PRICE
		========================= */
		var price = 0;
		if (product && typeof product.price !== "undefined") {
			price = Number(product.price) / 100;
		}
		if (!product || product.price == null || product.price === "" || !isFinite(price) || price < 0) {
			price = getVisiblePrice(card);
		}
		/* =========================
		   DISCOUNT
		========================= */
		var discount = 0;
		if (product && product.compare_at_price && product.price && Number(product.compare_at_price) > Number(product.price)) {
			discount = (Number(product.compare_at_price) - Number(product.price)) / 100;
		}
		/* =========================
		   VARIANT
		========================= */
		/**
		 * Importante:
		 *
		 * NO asignamos automáticamente
		 * XS / S / M / L.
		 *
		 * Mientras el usuario no haya
		 * seleccionado una talla,
		 * no existe una variante real
		 * elegida por el usuario.
		 *
		 * El color ya queda identificado
		 * mediante item_ref_col.
		 */
		var itemVariant = "";
		/* =========================
		   ITEM
		========================= */
		return {
			affiliation: CONFIG.brand,
			coupon: "",
			currency: CONFIG.currency,
			discount: discount,
			index: getProductIndex(card),
			item_brand: itemBrand,
			item_category: extra.category || "",
			item_category2: extra.category2 || "",
			item_category3: extra.category3 || "",
			item_category4: extra.category4 || "",
			item_category5: extra.category5 || "",
			/**
			 * Nuevo criterio:
			 *
			 * Shopify Product ID.
			 */
			item_id: String(itemId),
			/**
			 * Antigua referencia-color.
			 */
			item_ref_col: itemRefCol,
			item_image_url: itemImageUrl,
			item_list_id: list.item_list_id,
			item_list_name: list.item_list_name,
			item_name: itemName,
			item_variant: itemVariant,
			price: price
		};
	}
	/* ==========================================================
	   1. VIEW ITEM LIST CUSTOM
	   ==========================================================
	   Vista macro de la colección.
	========================================================== */
	function trackListView() {
		var list = getListContext();
		if (!list.item_list_id) {
			return;
		}
		/**
		 * Query params de filtros no crean
		 * una nueva vista macro.
		 *
		 * Usamos pathname + colección.
		 */
		var key = window.location.pathname + "::" + list.item_list_id;
		if (STATE.viewedLists.has(key)) {
			return;
		}
		STATE.viewedLists.add(key);
		pushEcommerceEvent({
			event: "view_item_list_custom",
			user_id: window.user_id || "",
			device_type: getDeviceType(),
			ecommerce: {
				item_list_id: list.item_list_id,
				item_list_name: list.item_list_name
			}
		});
	}
	/* ==========================================================
	   2. VIEW ITEM LIST PRODUCT
	   ==========================================================
	   Impresión REAL del producto.
	========================================================== */
	function getProductImpressionKey(item) {
		return [
			window.location.pathname,
			item.item_list_id,
			STATE.renderVersion,
			item.item_id,
			item.item_ref_col
		].join("::");
	}

	/* ==========================================================
	PRODUCT IMPRESSION BATCH
	========================================================== */

	/**
	 * Envía todos los productos acumulados en una sola tanda.
	 * Si por alguna razón hubiera productos pertenecientes a listas diferentes,
	 * los separa automáticamente.
	 */
	function flushProductImpressions() {
	clearTimeout(STATE.productImpressionFlushTimer);
	STATE.productImpressionFlushTimer = null;
	if (STATE.productImpressionQueue.length === 0) {
		return;
	}

	var queue = STATE.productImpressionQueue.slice();

	/**
	 * Limpiamos inmediatamente la cola.
	 */
	STATE.productImpressionQueue = [];
	STATE.productImpressionFlushTimer = null;

	/**
	 * Agrupamos por listado.
	 * Normalmente en una PLP habrá solo uno, pero así dejamos el tracking robusto.
	 */
	var groups = Object.create(null);

	queue.forEach(function (item) {
		var groupKey = item.item_list_id + "::" + item.item_list_name;

		if (!groups[groupKey]) {
		groups[groupKey] = {
			item_list_id: item.item_list_id,
			item_list_name: item.item_list_name,
			items: []
		};
		}

		groups[groupKey].items.push(item);
	});

	Object.keys(groups).forEach(function (groupKey) {
		var group = groups[groupKey];
		var pageContext = getPageContext();

		group.items.sort(function(a, b) {
			return a.index - b.index;
		});

		pushEcommerceEvent({
		event: "view_item_list_product",
		user_id: window.user_id || "",
		device_type: getDeviceType(),
		list_render: STATE.renderVersion,
		list_context: pageContext.list_context,
		page_location_relative: pageContext.page_location_relative,
		ecommerce: {
			item_list_id: group.item_list_id,
			item_list_name: group.item_list_name,
			items: group.items
		}
		});
	});
	}

	/**
	 * Programa el envío de la tanda.
	 * Esperamos unos milisegundos para que todos los productos visibles de la misma
	 * fila/viewport entren en la cola.
	 */
	function scheduleProductImpressionFlush() {
	if (STATE.productImpressionFlushTimer) {
		return;
	}

	STATE.productImpressionFlushTimer = setTimeout(function () {
		flushProductImpressions();
	}, CONFIG.impressionBatchDelay);
	}

	/**
	 * Registra una impresión, pero NO hace dataLayer.push inmediatamente.
	 * Primero la agrega a la cola.
	 */
	function sendProductImpression(card, forcedColorElement) {
	var item = buildProductItem(card, forcedColorElement);

	if (!item || !item.item_id) {
		return;
	}

	var key = getProductImpressionKey(item);

	/**
	 * DEDUPE
	 * Marcamos el producto como visto ANTES de meterlo en la cola.
	 * Así IntersectionObserver no puede meter dos veces el mismo producto
	 * mientras esperamos el batch.
	 */
	if (STATE.viewedProducts.has(key)) {
		return;
	}

	STATE.viewedProducts.add(key);

	/**
	 * Agregar producto a la tanda.
	 */
	STATE.productImpressionQueue.push(item);

	/**
	 * Programar envío agrupado.
	 */
	scheduleProductImpressionFlush();
	}

	/* ==========================================================
	   INTERSECTION OBSERVER
	========================================================== */

	function cancelVisibility(card) {
		var pending = STATE.visibilityTimers.get(card);
		if (pending) clearTimeout(pending.timer);
		STATE.visibilityTimers.delete(card);
	}
	function cancelAllVisibility() {
		STATE.visibilityTimers.forEach(function(pending, card) { cancelVisibility(card); });
	}
	function handleIntersections(entries) {
		entries.forEach(function(entry) {
			var card = entry.target;
			if (document.hidden || !card.isConnected || !entry.isIntersecting ||
				entry.intersectionRatio < CONFIG.productVisibilityThreshold) {
				cancelVisibility(card);
				return;
			}
			if (STATE.visibilityTimers.has(card)) return;
			var item = buildProductItem(card);
			if (!item || !item.item_id) return;
			var key = getProductImpressionKey(item);
			if (STATE.viewedProducts.has(key)) return;
			var pending = { key: key, timer: null };
			pending.timer = setTimeout(function() {
				// Procesar salidas pendientes antes de acreditar los 500 ms.
				handleIntersections(productObserver.takeRecords());
				if (STATE.visibilityTimers.get(card) !== pending) return;
				STATE.visibilityTimers.delete(card);
				if (document.hidden || !card.isConnected) return;
				var current = buildProductItem(card);
				if (!current || getProductImpressionKey(current) !== key) return;
				sendProductImpression(card);
			}, CONFIG.productVisibilityTime);
			STATE.visibilityTimers.set(card, pending);
		});
	}
	var productObserver = typeof IntersectionObserver === "function"
		? new IntersectionObserver(handleIntersections, {
			threshold: [0, CONFIG.productVisibilityThreshold]
		}) : null;

	function observeProductCards() {
		if (!productObserver) return;
		STATE.observedCards.forEach(function(card) {
			if (!card.isConnected) {
				cancelVisibility(card);
				productObserver.unobserve(card);
				STATE.observedCards.delete(card);
			}
		});
		document.querySelectorAll(CONFIG.productSelector).forEach(function(card) {
			if (STATE.observedCards.has(card)) return;
			STATE.observedCards.add(card);
			productObserver.observe(card);
		});
	}
	function refreshProductObservers() {
		cancelAllVisibility();
		if (!productObserver) return;
		productObserver.takeRecords();
		STATE.observedCards.forEach(function(card) {
			productObserver.unobserve(card);
			if (card.isConnected) productObserver.observe(card);
			else STATE.observedCards.delete(card);
		});
	}
	function bumpRenderVersion() {
		// Vaciar con el contexto anterior antes de incrementar la versión.
		flushProductImpressions();
		cancelAllVisibility();
		STATE.renderVersion++;
		STATE.viewedProducts.clear();
		// Compatibilidad con el tema: confirmar este retraso contra su AJAX real.
		setTimeout(function() {
			observeProductCards();
			refreshProductObservers();
		}, 250);
	}
	document.addEventListener("visibilitychange", function() {
		if (document.hidden) {
			cancelAllVisibility();
			flushProductImpressions();
		} else refreshProductObservers();
	});
	window.addEventListener("pagehide", function() {
		cancelAllVisibility();
		flushProductImpressions();
	});
	window.addEventListener("pageshow", function(event) {
		if (event.persisted) refreshProductObservers();
	});

	/* ==========================================================
	   3. SELECT ITEM CUSTOM
	   ==========================================================
	   Únicamente navegación real hacia PDP.
	========================================================== */
	document.addEventListener("click", function(event) {
		var link = getEventElement(event).closest(".custom-card-img-url, " + ".hdt-card-product__title");
		if (!link) return;
		var card = link.closest(CONFIG.productSelector);
		if (!card) return;
		var item = buildProductItem(card);
		if (!item) return;
		var source = link.classList.contains("hdt-card-product__title") ? "title" : "image";
		pushEcommerceEvent({
			event: "select_item",
			user_id: window.user_id || "",
			device_type: getDeviceType(),
			selection_source: source,
			ecommerce: {
				item_list_id: item.item_list_id,
				item_list_name: item.item_list_name,
				items: [
					item
				]
			}
		});
	});
	/* ==========================================================
	   4. CHANGE ITEM VARIANT PLP
	   ==========================================================
	   Cambio de color en la card.
	========================================================== */
	document.addEventListener("click", function(event) {
			var swatch = getEventElement(event).closest(".t4s-product-colors " + ".t4-variant-custom");
			if (!swatch) return;
			var card = swatch.closest(CONFIG.productSelector);
			if (!card) return;
			/**
			 * Estamos en CAPTURE.
			 *
			 * Aquí todavía podemos saber
			 * cuál era el color anterior.
			 */
			var previousSwatch = getSelectedColorElement(card);
			if (previousSwatch !== swatch) cancelVisibility(card);
			var previousItem = previousSwatch ? buildProductItem(card, previousSwatch) : null;
			/**
			 * Esperamos a que Shopify/theme
			 * termine de modificar la card.
			 */
			setTimeout(function() {
				if (!card.isConnected || getSelectedColorElement(card) !== swatch) return;
				var newItem = buildProductItem(card, swatch);
				if (!newItem) return;
				/**
				 * Click sobre el mismo color:
				 * no es realmente un cambio.
				 */
				if (previousItem && previousItem.item_id === newItem.item_id && previousItem.item_ref_col === newItem.item_ref_col) {
					return;
				}
				pushEcommerceEvent({
					event: "change_item_variant_plp",
					user_id: window.user_id || "",
					device_type: getDeviceType(),
					variant_type: "color",
					previous_item_id: previousItem ? previousItem.item_id : "",
					previous_item_ref_col: previousItem ? previousItem.item_ref_col : "",
					new_item_id: newItem.item_id,
					new_item_ref_col: newItem.item_ref_col,
					ecommerce: {
						item_list_id: newItem.item_list_id,
						item_list_name: newItem.item_list_name,
						items: [
							newItem
						]
					}
				});
				/**
				 * Si el nuevo color/producto
				 * ya está visible, también debe
				 * poder generar impresión real.
				 *
				 * Dedupe evita duplicados.
				 */

				// Usar el mismo observador y timer cancelable para todos los colores.
				cancelVisibility(card);
				if (productObserver && card.isConnected) {
					productObserver.unobserve(card);
					productObserver.observe(card);
				}

			}, 0);
		},
		/**
		 * CAPTURE.
		 *
		 * Necesario para obtener el swatch
		 * seleccionado ANTES de que el theme
		 * actualice la card.
		 */
		true);
	/* ==========================================================
	   5. MENU INTERACTION
	========================================================== */
	function getOwnText(element) {
		if (!element) return "";
		var clone = element.cloneNode(true);
		var nested = clone.querySelectorAll("ul, ol, " + ".submenu, " + ".sub-menu, " + ".mega-menu");
		nested.forEach(function(node) {
			node.remove();
		});
		return cleanText(clone.textContent);
	}

	function getMenuLabel(li) {
		if (!li) return "";
		for (var i = 0; i < li.children.length; i++) {
			var child = li.children[i];
			if (child.tagName === "A" || child.tagName === "BUTTON" || child.tagName === "SUMMARY") {
				return getOwnText(child);
			}
		}
		var fallback = li.querySelector("a, button, summary, " + '[role="menuitem"]');
		return fallback ? getOwnText(fallback) : "";
	}

	function getMenuPath(clicked, root) {
		var path = [];
		var current = clicked;
		while (current && current !== root) {
			if (current.tagName === "LI") {
				var text = getMenuLabel(current);
				if (text) {
					path.unshift(text);
				}
			}
			current = current.parentElement;
		}
		var clickedText = getOwnText(clicked);
		if (clickedText && (!path.length || path[path.length - 1] !== clickedText)) {
			path.push(clickedText);
		}
		return path;
	}
	document.addEventListener("click", function(event) {
		var clicked = getEventElement(event).closest("a, button, summary, " + '[role="menuitem"]');
		if (!clicked) return;
		// La flecha móvil no tiene texto: usar el summary que nombra la categoría.
		if (clicked.matches("button.mox-mmmb__toggle")) {
			clicked = clicked.closest("summary");
			if (!clicked) return;
		}
		var desktop = clicked.closest("nav.mox-nav");
		var mobile = clicked.closest("#menu_mobile");
		if (!desktop && !mobile) {
			return;
		}
		var root = desktop || mobile;
		var menuType = desktop ? "desktop" : "mobile";
		var path = getMenuPath(clicked, root);
		var item = getOwnText(clicked);
		if (!item) return;
		var url = "";
		if (clicked.tagName === "A") {
			url = clicked.getAttribute("href") || "";
		}
		var action = url && url !== "#" && url.indexOf("javascript:") !== 0 ? "navigate" : "expand";
		pushEvent({
			event: "menu_interaction",
			user_id: window.user_id || "",
			device_type: getDeviceType(),
			menu_type: menuType,
			menu_level: path.length,
			menu_root: path.length ? path[0] : "",
			menu_parent: path.length >= 2 ? path[path.length - 2] : "",
			menu_item: item,
			menu_path: path.join(" > "),
			menu_url: url,
			menu_action: action
		});
	}, true); // Captura: los enlaces desktop detienen la propagación.

	/* 5B. Apertura confirmada del menú hamburguesa.
	   Solo genera menu_open tras un clic y la aparición de open-dialog.
	   No cuenta clics fallidos ni aperturas automáticas. */
	var menuOpenPending = null;
	function stopMenuOpenWatch() {
		if (!menuOpenPending) return;
		menuOpenPending.observer.disconnect();
		clearTimeout(menuOpenPending.timeout);
		menuOpenPending = null;
	}
	function confirmMobileMenuOpen() {
		if (!menuOpenPending) return;
		var drawer = document.getElementById("menu_mobile");
		if (!drawer || !drawer.hasAttribute("open-dialog")) return;
		var page = menuOpenPending.page;
		stopMenuOpenWatch();
		pushEvent({
			event: "menu_open",
			user_id: window.user_id || "",
			device_type: getDeviceType(),
			menu_type: "mobile",
			menu_source: "hamburger",
			list_context: page.list_context,
			page_location_relative: page.page_location_relative
		});
	}
	document.addEventListener("click", function(event) {
		var button = getEventElement(event).closest('button[aria-controls="menu_mobile"]');
		if (!button) return;
		var drawer = document.getElementById("menu_mobile");
		if (drawer && drawer.hasAttribute("open-dialog")) return;
		if (menuOpenPending) return;
		var observer = new MutationObserver(confirmMobileMenuOpen);
		menuOpenPending = { observer: observer, timeout: null, page: getPageContext() };
		observer.observe(document.documentElement, {
			subtree: true, childList: true, attributes: true,
			attributeFilter: ["open-dialog"]
		});
		menuOpenPending.timeout = setTimeout(stopMenuOpenWatch, 3000);
	}, true);
	window.addEventListener("pagehide", stopMenuOpenWatch);

	/* ==========================================================
	   6. PLP SORT INTERACTION
	========================================================== */
	document.addEventListener("click", function(event) {
		var option = getEventElement(event).closest('hdt-richlist' + '[role="listbox"]' + '[id^="listbox"] ' + 'button[role="option"]');
		if (!option) return;
		var richlist = option.closest('hdt-richlist' + '[role="listbox"]');
		var list = getListContext();
		var sortValue = option.value || option.getAttribute("value") || "";
		var sortLabel = cleanText(option.textContent);
		/**
		 * Evitamos enviar click sobre
		 * la opción ya seleccionada.
		 */
		if (option.getAttribute("aria-selected") === "true") {
			return;
		}
		pushEvent({
			event: "plp_sort_interaction",
			user_id: window.user_id || "",
			device_type: getDeviceType(),
			item_list_id: list.item_list_id,
			item_list_name: list.item_list_name,
			sort_value: sortValue,
			sort_label: sortLabel
		});
		bumpRenderVersion();
	}, true);
	/* ==========================================================
	   FILTER HELPERS
	========================================================== */
	function getFilterGroup(input) {
		if (!input) return "";
		/**
		 * MOBILE / accordion.
		 */
		var group = input.closest(".hdt-filter-group");
		if (group) {
			var summary = group.querySelector(".hdt-filter-group-summary " + ".hdt-facet-title_group > span:first-child");
			if (summary) {
				return cleanText(summary.textContent);
			}
		}
		/**
		 * DESKTOP.
		 */
		var customGroup = input.closest(".hdt-custom-filter-item");
		if (customGroup) {
			var button = customGroup.querySelector(':scope > button ' + ".hdt-facet-title_group > span, " + ':scope > button > span:first-child');
			if (button) {
				return cleanText(button.textContent);
			}
		}
		/**
		 * Precio.
		 */
		if (input.name && input.name.indexOf("filter.v.price") === 0) {
			return "Precio";
		}
		return "";
	}

	function getPriceValues(form) {
		var minInput = form.querySelector('[name="filter.v.price.gte"]');
		var maxInput = form.querySelector('[name="filter.v.price.lte"]');
		return {
			min: minInput && minInput.value !== "" ? Number(minInput.value) : 0,
			max: maxInput && maxInput.value !== "" ? Number(maxInput.value) : 0
		};
	}
	/* ==========================================================
	   7. PLP FILTER INTERACTION
	========================================================== */
	document.addEventListener("change", function(event) {
		var input = event.target;
		if (!input || input.tagName !== "INPUT") {
			return;
		}
		var form = input.closest('form[is="hdt-facet-filters-form"], ' + 'form[id*="hdt-facet-filters-form"]');
		if (!form) return;
		/**
		 * Solo filtros Shopify.
		 */
		var inputName = input.name || "";
		var isPriceRange = input.type === "range";
		if (inputName.indexOf("filter.") !== 0 && !isPriceRange) {
			return;
		}
		var list = getListContext();
		var group = getFilterGroup(input);
		/* =========================
		   PRICE
		========================= */
		if (group === "Precio" || inputName.indexOf("filter.v.price") === 0 || isPriceRange) {
			var prices = getPriceValues(form);
			pushEvent({
				event: "plp_filter_interaction",
				user_id: window.user_id || "",
				device_type: getDeviceType(),
				item_list_id: list.item_list_id,
				item_list_name: list.item_list_name,
				filter_group: "Precio",
				/**
				 * Canonical field.
				 */
				filter_name: "filter.v.price",
				filter_name_min: "filter.v.price.gte",
				filter_name_max: "filter.v.price.lte",
				filter_value: prices.min + "-" + prices.max,
				filter_min: prices.min,
				filter_max: prices.max,
				filter_action: "apply"
			});
			bumpRenderVersion();
			return;
		}
		/* =========================
		   CHECKBOX / RADIO
		========================= */
		var action = "apply";
		if (input.type === "checkbox") {
			action = input.checked ? "apply" : "remove";
		}
		pushEvent({
			event: "plp_filter_interaction",
			user_id: window.user_id || "",
			device_type: getDeviceType(),
			item_list_id: list.item_list_id,
			item_list_name: list.item_list_name,
			/**
			 * Nombre amigable.
			 *
			 * Ej:
			 *
			 * Tipo de prenda
			 * Uso
			 * Talla
			 * Color
			 */
			filter_group: group,
			/**
			 * Nombre técnico Shopify.
			 *
			 * Ej:
			 *
			 * filter.p.m.custom.grupo_de_art_culos
			 * filter.p.m.custom.uso
			 * filter.v.option.talla
			 */
			filter_name: inputName,
			filter_value: input.value || "",
			filter_action: action
		});
		bumpRenderVersion();
	});
	/* ==========================================================
	   DOM OBSERVER
	   ==========================================================
	   Shopify puede reemplazar productos/filtros
	   mediante AJAX.
	========================================================== */
	var domRefreshTimer = null;
	var domObserver = new MutationObserver(function(records) {
		var relevant = records.some(function(record) {
			if (record.target.closest && record.target.closest(CONFIG.productSelector)) return true;
			return Array.prototype.some.call(record.addedNodes, hasCards) ||
				Array.prototype.some.call(record.removedNodes, hasCards);
		});
		if (!relevant || domRefreshTimer !== null) return;
		domRefreshTimer = setTimeout(function() {
			domRefreshTimer = null;
			observeProductCards();
			trackListView();
		}, 50);
	});
	function hasCards(node) {
		return node.nodeType === 1 && (node.matches(CONFIG.productSelector) ||
			!!node.querySelector(CONFIG.productSelector));
	}

	function init() {
		trackListView();
		observeProductCards();
		domObserver.observe(document.documentElement, {
			childList: true,
			subtree: true
		});
		debugLog("init", {
			status: "loaded"
		});
	}
	/* ==========================================================
	   INIT
	========================================================== */
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();